export const SEPARATOR_LINE_FORM_VALIDATION = '\n';
export const UNKNOWN_ERROR = 'Sorry, something has gone wrong. Try to reload the page, or contact Saagie support.';
